export default {
  lang: '中文简体',
  refresh: '刷新',
  back: '后退',
  fullscreen: '全屏',
  exitfullscreen: '退出全屏',
  browserecords: '浏览记录',
  login: '登录',
  logout: '退出登录',
  username: '用户帐号',
  password: '用户密码',
  failedlogin: '登陆失效',
  failedloginmessage: '请尝试重新登录后再操作',
  404: '当您看到此页面时，意味着服务器找不到您所需要的页面...',

  menu: require('./menu'),
  message: require('./message'),
  name: require('./name')
}